import { useEffect, useState } from "react";
import { FaRegEdit, FaTrash } from "react-icons/fa";
import "./index.css";
import { usePlayerAccount } from "../../../../../APIContext/PlayerAccountContext";
import AddPlayerProfileModal from "../../../../../Components/AddPlayerProfileModal/AddPlayerProfileModal";
import EditPlayerProfileModal from "../../../../../Components/EditPlayerProfileModal/EditPlayerProfileModal";
import Swal from "sweetalert2";

const Player = () => {
  const { players, fetchPlayers, fetchPlayersPackages, deletePlayer } =
    usePlayerAccount();

  const [data, setData] = useState([]);
  const [activePlayerId, setActivePlayerId] = useState(null); // ✅ new
  const [packageData, setPackageData] = useState([]);
  const [showModalAdd, setShowModalAdd] = useState(false);
  const [showModalEdit, setShowModalEdit] = useState(false);
  const [selectedPlayer, setSelectedPlayer] = useState({});

  useEffect(() => {
    fetchPlayers();
  }, [showModalAdd, showModalEdit]);

  useEffect(() => {
    if (players) {
      setData(players);
    }
  }, [players]);

  // ✅ Fetch packages for selected player only
  const handlePlayerStats = async (playerId) => {
    try {
      const data = await fetchPlayersPackages(playerId);
      setPackageData(data || []);
    } catch (err) {
      setPackageData([]);
      alert("Error fetching player packages");
    }
  };

  const handlePlayerDelete = async (playerId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This action cannot be undone!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#f7931a",
      cancelButtonColor: "#1C1C1C",
      confirmButtonText: "Yes, delete!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await deletePlayer(playerId);
          fetchPlayers();
        } catch (err) {
          Swal.fire("Error!", "Something went wrong.", "error");
        }
      }
    });
  };

  function getLocalDate(utcDateTime) {
    const localDate = new Date(utcDateTime);
    return localDate.toLocaleDateString("en-IN", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  }

  return (
    <>
      <div
        style={{ filter: "brightness(1.28)" }}
        className="profile-content-area bg-custom"
      >
        <div className="player-container">
          <div className="player-header">
            <h2 className="text-clip">Your Player Details</h2>
            <button
              className="add-player-btn"
              onClick={() => setShowModalAdd(true)}
            >
              Add a New Player
            </button>
          </div>

          {data.length === 0 && <p className="not-found">No data found</p>}

          {data.map((player, index) => (
            <div
              className="player-card-dash bg-custom brightness"
              key={player.id}
            >
              <div className="player-card-header">
                <h3 className="text-clip">Player {index + 1} Details</h3>

                <div className="player-card-actions">
                  <button
                    className="edit-btn"
                    onClick={() => {
                      setSelectedPlayer(player);
                      setShowModalEdit(true);
                    }}
                  >
                    <span className="brightness">
                      Edit Details <FaRegEdit />
                    </span>
                  </button>

                  <button
                    className="edit-btn"
                    onClick={() => handlePlayerDelete(player.id)}
                  >
                    <span className="brightness">
                      Delete Player <FaTrash />
                    </span>
                  </button>
                </div>
              </div>

              <div className="player-info">
                <div className="player-image">
                  <img src={player.profile_picture} alt="" />
                </div>

                <div className="player-details">
                  <div className="player-row">
                    <div className="player-field">
                      <p className="label text-clip">Name</p>
                      <span className="value text-clip">{player.name}</span>
                    </div>
                    <div className="player-field">
                      <p className="label text-clip">Grade</p>
                      <span className="value text-clip">{player.grade}</span>
                    </div>
                    <div className="player-field">
                      <p className="label text-clip">Gender</p>
                      <span className="value text-clip">{player.gender}</span>
                    </div>
                    <div className="player-field">
                      <p className="label text-clip">Jersey Size</p>
                      <span className="value text-clip">
                        {player.jersey_size}
                      </span>
                    </div>
                  </div>

                  <div className="player-row">
                    <div className="player-field">
                      <p className="label text-clip">School</p>
                      <span className="value text-clip">
                        {player.school_name}
                      </span>
                    </div>
                    <div className="player-field">
                      <p className="label text-clip">DOB</p>
                      <span className="value text-clip">
                        {player.date_of_birth}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="player-footer">
                <button
                  className="view-stats-btn"
                  onClick={() => {
                    if (activePlayerId === player.id) {
                      setActivePlayerId(null);
                    } else {
                      setActivePlayerId(player.id);
                      handlePlayerStats(player.id);
                    }
                  }}
                >
                  <span className="text-clip">
                    {activePlayerId === player.id
                      ? "Hide Player Stats"
                      : "View Player Stats"}
                  </span>
                </button>
              </div>

              {/* ✅ INDIVIDUAL RENDERING */}
              {activePlayerId === player.id && (
                <div className="player-stats-section">
                  <hr className="divider" />
                  <h4 className="section-title">Packages Details</h4>

                  <div className="package-table">
                    <div className="table-header">
                      <span className="text-clip">Package Name</span>
                      <span className="text-clip">Price</span>
                      <span className="text-clip">Remaining Sessions</span>
                      <span className="text-clip">Type</span>
                      <span className="text-clip">Date</span>
                      <span className="text-clip">Status</span>
                    </div>

                    {packageData.length > 0 ? (
                      packageData.map((item, index) => (
                        <div className="table-row" key={index}>
                          <span className="text-clip">
                            {item.package?.name || ""}
                          </span>
                          <span className="text-clip">
                            {item.package?.price || ""}
                          </span>
                          <span className="text-clip">
                            {item.remaining_sessions || ""}
                          </span>
                          <span className="text-clip">
                            {item.is_unlimited ? "Unlimited" : "Limited"}
                          </span>
                          <span className="text-clip">
                            {getLocalDate(item.start_date)}
                          </span>
                          <span className="text-clip">{item.status || ""}</span>
                        </div>
                      ))
                    ) : (
                      <div className="no-package text-clip">
                        No Packages Available
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
      {showModalAdd && (
        <AddPlayerProfileModal onClose={() => setShowModalAdd(false)} />
      )}
      {showModalEdit && (
        <EditPlayerProfileModal
          player={selectedPlayer}
          onClose={() => setShowModalEdit(false)}
        />
      )}
    </>
  );
};

export default Player;
